import React from 'react';
import { classnames } from '../../../utils/classnames';
export default function RadioButtonGroup({ onChange, name, options, value, defaultValue }) {
  const handleChange = (value) => {
    onChange(name, value);
  };

  return (
    <div className="radio-button-group">
      {options.map((item) => (
        <RadioButton
          key={item.value}
          onChange={handleChange}
          value={item.value}
          label={item.label}
          checked={(value ? value : defaultValue) === item.value}
        />
      ))}
    </div>
  );
}

export function RadioButton({ onChange, value, label, checked }) {
  const handleChange = () => {
    onChange(value);
  };

  return (
    <div className="radio-button">
      <input
        className={classnames('radio-button-item', checked && 'radio-button-item-checked')}
        type="radio"
        name="radio"
        id={`radio-${value}`}
        onChange={handleChange}
        checked={checked}
      />
      <label htmlFor={`radio-${value}`}>{label}</label>
    </div>
  );
}
